<template lang="html">
  <transition
    name="toast"
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
  >
    <div
      v-if="active"
      ref="toast"
      :style="stylex"
      class="ms-component ms-toastfications"
      :class="[`ms-toast-${position}`,{'activetoast':active}]"
      @click="clicktoast">
      <div class="content-toast">
        <div class="ms-icon-toast mi mi-34" :class="`mi-notifications-${type}`"></div>
        <div class="con-text-toast">
          <p v-show="text" v-html="text"/>
          <slot/>
        </div>
      </div>
      <span
        :style="fillingStyle"
        class="filling"/>
    </div>
  </transition>
</template>

<script>
export default {
	data: () => ({
		type: 'success',
		time: 5000,
		position: 'bottom-right',
		color: '#fff',
		colorText: '#212121',
		active: true,
		text: null,
		fullWidth: false,
		cords: {
			top: null,
			left: null,
			right: null,
			bottom: null,
		},
		widthx: 0,
		fixed: false,
		mousedowntoast: false,
	}),
	computed: {
		fillingStyle() {
			return {
				left: this.cords.left ? '-100px' : null,
				right: this.cords.right ? '-100px' : null,
				background: this.color,
				height: `${this.widthx * 2}px`,
				width: `${this.widthx * 2}px`,
			};
		},
		stylex() {
			return {
				...this.cords,
				color: this.colorText,
				width: this.fullWidth ? `calc(100% - 14px)` : ``,
				maxWidth: this.fullWidth ? 'none' : `350px`,
				border:
					this.type == 'success' ? '1px solid #77D031' : '1px solid #FF7777',
			};
		},
	},
	created() {
		setTimeout(() => {
			this.movertoasts();
		}, 0);
		this.changeCords();
	},
	mounted() {
		setTimeout(() => {
			this.widthx = this.$refs.toast.clientWidth;
		}, 0);

		if (!this.fixed) {
			setTimeout(() => {
				this.closetoast();
			}, this.time);
		}
	},
	methods: {
		clicktoast() {
			this.active = false;
			this.click ? this.click() : null;
		},
		beforeEnter(el) {
			el.style.opacity = 0;
		},
		enter(el, done) {
			el.style.opacity = 1;
			done();
		},
		leave(el, done) {
			el.style.opacity = 0;
			let transformx = el.style.transform;
			if (this.cords.left == '50%' || this.fullWidth) {
				transformx += ` translateY(${this.cords.top ? '-' : ''}100%)`;
			} else {
				transformx += ` translateX(${this.cords.left ? '-' : ''}100%)`;
			}
			el.style.transform = transformx;
			setTimeout(() => {
				done();
				this.movertoasts();
			}, 150);
		},
		closetoast() {
			this.active = false;
		},
		changeCords() {
			let positions = this.position.split('-');
			let search = (text) => {
				return positions.indexOf(text) != -1;
			};
			if (search('top')) {
				this.cords.top = '0px';
			}
			if (search('bottom')) {
				this.cords.bottom = '0px';
			}
			if (search('right')) {
				this.cords.right = '0px';
			}
			if (search('left')) {
				this.cords.left = '0px';
			}

			if (search('center')) {
				this.cords.left = 'calc(50% - 200px)';
			}
		},
		movertoasts() {
			let toastsx = document.querySelectorAll('.ms-toast-' + this.position);
			for (let i = 0; i < toastsx.length; i++) {
				let hx = 10;
				for (let i2 = 0; i2 < i; i2++) {
					hx += toastsx[i2].clientHeight + 6;
				}
				if (this.position.search('center') == -1) {
					if (this.position.search('top') != -1) {
						toastsx[i].style.transform = `translatey(${hx}px)`;
					} else if (this.position.search('bottom') != -1) {
						toastsx[i].style.transform = `translatey(-${hx}px)`;
					}
				}
				if (
					this.position.search('top') != -1 &&
					this.position.search('center') != -1
				) {
					toastsx[i].style.transform = `translatey(${hx}px)`;
					toastsx[i].style.zIndex = 10000 - i;
				}
				if (
					this.position.search('bottom') != -1 &&
					this.position.search('center') != -1
				) {
					toastsx[i].style.transform = `translate(-50%,-${hx}px)`;
					toastsx[i].style.zIndex = 10000 - i;
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/ms-Toast.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/ms-Toast.scss';
}
</style>
